import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImageAltText: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconImageAltText"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM5 15V19H19V15H5ZM19 13V5H5V9.58579L8 6.58579L14.4142 13H19ZM13 8.5C13 7.11929 14.1193 6 15.5 6C16.8807 6 18 7.11929 18 8.5C18 9.88071 16.8807 11 15.5 11C14.1193 11 13 9.88071 13 8.5ZM6 16H13V18H6V16ZM14 16H18V18H14V16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImageAltText;
